/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Exception_HelperInputs */



/**
* | output |
* | --- |
* | "Want a team lead or reviewer to see everyone's chats without making them admin? Use ⋯ → Edit Permissions next to their name below and tick “Can see everyone'..." |
*
* @param {Project_Private_Chats_Exception_HelperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_exception_helper = /** @type {((inputs?: Project_Private_Chats_Exception_HelperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Exception_HelperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Soll eine Teamleitung oder eine prüfende Person die Chats aller Mitglieder sehen, ohne Admin zu werden? Wählen Sie unten neben dem Namen ⋯ → Berechtigungen bearbeiten und setzen Sie das Häkchen bei „Darf die Chats aller Mitglieder sehen“.")
	return /** @type {LocalizedString} */ ("Want a team lead or reviewer to see everyone's chats without making them admin? Use ⋯ → Edit Permissions next to their name below and tick “Can see everyone's chats”.")
});